import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ConfirmationModal } from '../../../../../../../components/ConfirmationModal';

interface IDeleteSegmentationConfirmationModalProps {
  showSegmentationDeleteConfirmationModal: boolean;
  onSegmentationDeleteConfirm: () => Promise<void>;
  onSegmentationDeleteCancel: () => void;
}

export const DeleteSegmentationConfirmationModal = observer((props: IDeleteSegmentationConfirmationModalProps): ReactElement => {
  return (
    <ConfirmationModal
      confirmationHeader={'delete_segmentation_confirmation'}
      confirmationQuestion={'delete_segmentation_confirmation_body'}
      onCancel={props.onSegmentationDeleteCancel}
      onConfirm={props.onSegmentationDeleteConfirm}
      showModal={props.showSegmentationDeleteConfirmationModal}
      confirmationYes={'delete'}
    />
  );
});
